import React from "react";
import dayjs from 'dayjs';

import { TailwindDatePicker } from "../../Tailwind";
import { useUpdateFieldValue } from "../../../shared/hooks/mutations/useUpdateFieldValue";
import { useSaveIndicator } from "../../../hooks/useSaveIndicator";
import SaveIndicator from "../../SaveIndicator";
import FieldError from "../FieldError";
import { useEditorStore } from "../../../shared/stores/useEditorStore";
import { formatDateForApi } from "../../../utils/dateFormat";

export default function DateField({ name, field }) {
    const [mounted, setMounted] = React.useState(false);
    const { status: saveStatus, trigger: triggerSave, resolve: resolveSave } = useSaveIndicator();
    const updateField = useUpdateFieldValue();
    const isReadOnly = !useEditorStore(s => s.userRights.right_to_write);
    const scenarioId = useEditorStore(s => s.scenarioId);

    const reloadLocalState = () => {
        setMounted(!mounted);
    }

    // Convert dayjs to Date for TailwindDatePicker
    // Gérer le cas où currentValue est undefined (nouveau model data)
    const safeCurrentValue = field.currentValue?.value ?? field.value?.value ?? null;
    const currentDate = safeCurrentValue
        ? (dayjs.isDayjs(safeCurrentValue) ? safeCurrentValue.toDate() : new Date(safeCurrentValue))
        : null;

    const handleChange = (newValue: Date | null) => {
        field.compute_error = null;
        reloadLocalState();
        const apiValue = formatDateForApi(newValue);
        const dayjsValue = apiValue ? dayjs(newValue) : null;

        triggerSave();
        updateField.mutate(
            { id: field.id, value: apiValue, scenarioId: scenarioId ?? 0 },
            {
                onSuccess: () => {
                    if (field.currentValue) {
                        field.currentValue.value = dayjsValue;
                    }
                    resolveSave();
                    reloadLocalState();
                },
            }
        );
    };

    return (
        <div className="h-auto mb-1">
            <div className="flex flex-row items-center">
                <TailwindDatePicker
                    value={currentDate}
                    onChange={handleChange}
                    placeholder={name}
                    disabled={isReadOnly}
                    className="w-[200px]"
                />
                <SaveIndicator status={saveStatus} className="ml-2" />
            </div>
            <FieldError field={field} />
        </div>
    )
}
